import styled from "styled-components";
import React from "react";
import { FlexContainer,ScrollableContainer } from "../../components/styled";
import ProgressBar from "../../components/shared/progressBar";
import DeckCard from "../../components/shared/deckCard";
import { PrimaryButton } from "../../components/styled";
import SyntesisBg from "../../assets/images/background/syntesisbg.png";
import SyntesisCard from "../../assets/images/syntesisCard.png";
import { useCryptidSelectModal } from "../../hooks/useCryptidSelectModal";
import { useUpgradeResultModal } from "../../hooks/useUpgradeResultModal";
import { useState,useEffect } from "react";
import { useToaster } from "../../hooks/useToaster";
// import {useWalletContext} from "../../context/WalletContext";
import { getSyntheses } from "../../service/main/api";
import CustomSelect from "../../components/shared/customSelect";
import { getInAppTokens } from "../../service/main/api";
import { useUserContext } from "../../context/UserContext";
import { synthesisCard } from "../../service/main/api";
import { useLoading } from "../../context/LoadingContext";
import { floatCard } from "../../components/styled/animations";


const Syntesis = (props) => {
        const {user,fetchUser} = useUserContext();
        const [userCards,setUserCards] = useState([]);
        const [synthesisType,setSystesisType] = useState("Normal");
        const [selectedCards,setSelectedCards] = useState([]);
        const [selectableCards,setSelectableCards] = useState([]);
        const depositAddress = process.env.REACT_APP_JETTON_WALLET_ADDRESS || "";
        const MaterialCards = Array(3).fill(0).map((_,i) => <DeckCard card={selectedCards[i]} clickAction={()=>openCryptidSelectModal(selectableCards,onCardSelected, true, selectedCards, 3)} containerStyle={{maxWidth:"66px"}} key={i} />);
        const {openCryptidSelectModal,closeCryptidSelectModal} = useCryptidSelectModal();
        const {openUpgradeResultModal} = useUpgradeResultModal();
        const {showToaster} = useToaster();
        const [synthesisData,setSynthesisData] = useState(null);
        const {walletDetails,tonConnectUI} = {};
        const [probabilities,setProbabilities] = useState([]);
        const [craftKey,setCraftKey] = useState(0);
        const {setIsLoading} = useLoading();
        useEffect(() => {
          if(props?.cards && props.cards.length > 0){
            setUserCards(props.cards);
            getSynthesesData();
            prepareCraftKey();
          }
          
        },[props?.cards]);
     const prepareCraftKey = async () => {
       try {
        setIsLoading(true);
          const response = await getInAppTokens();
          if(response?.success){
            const token = response.data.find(t=>t.name === "Craft Key");
            if(token){
              setCraftKey(token);
            }
          }
          setIsLoading(false);
       } catch (error) {
        setIsLoading(false);
         console.log(error);
        
       }
     };
        const onCardSelected = (cards) => {
            switch(synthesisType.name){
              case "Normal":
                if(cards.some((item) => item?.rarity?.name !== "Normal")){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only Normal cards can be used as material."});
                  return;
                }
                if(cards.some(item => item.level.value !== 2 && item?.level.value !== 3)){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only level 2 and 3 cards can be used as material."});
                  return;
                }
                break;
              case "NormalLv3":
                if(cards.some((item) => item?.rarity?.name !== "Normal")){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only Normal cards can be used as material."});
                  return;
                }
                if(cards.some(item => item.level.value !== 3)){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only level 3 cards can be used as material."});
                  return;
                }
                break;
              case "Rare":
                if(cards.some((item) => item?.rarity?.name !== "Rare")){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only Rare cards can be used as material."});
                  return;
                }
                if(cards.some(item => item.level.value !== 2 && item?.level.value !== 3)){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only level 2 and 3 cards can be used as material."});
                  return;
                }
                break;
                case "RareLv3":
                  if(cards.some((item) => item?.rarity?.name !== "Rare")){
                    closeCryptidSelectModal();
                    showToaster({type:"error",message:"Only Rare cards can be used as material."});
                    return;
                  }
                  if(cards.some(item => item?.level.value !== 3)){
                    closeCryptidSelectModal();
                    showToaster({type:"error",message:"Only level 2 and 3 cards can be used as material."});
                    return;
                  }
                  break;
              case "Unique":
                if(cards.some((item) => item?.rarity?.name !== "Unique")){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only Unique cards can be used as material."});
                  return;
                }
                if(cards.some(item => item.level.value !== 3)){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only level 4 cards can be used as material."});
                  return;
                }
                break;
              case "UniqueLv3":
                if(cards.some((item) => item?.rarity?.name !== "Unique")){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only Unique cards can be used as material."});
                  return;
                }
                if(cards.some(item => item.level.value !== 3)){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only level 3 cards can be used as material."});
                  return;
                }
                break;
              case "Legend":
                if(cards.some((item) => item?.rarity?.name !== "Legend")){
                  closeCryptidSelectModal();
                  showToaster({type:"error",message:"Only Legend cards can be used as material."});
                  return;
                }
                break;
              default:
                break;
            }
            let currentSelectedCards = selectedCards;
            // if(currentSelectedCards.find(c=>c._id === card._id)){
            //   closeCryptidSelectModal();
            //   showToaster({type:"error",message:"You have already selected this card."});
            //   return;
            // }
            // if(currentSelectedCards.length >= 3){
            //     currentSelectedCards.shift();
            // }
            setSelectedCards(cards);
            closeCryptidSelectModal();
        }
        const getSynthesesData = async () => {
          const response = await getSyntheses();
          if(response?.success){
            setSynthesisData(response.data);
            setSystesisType(response.data[0]);
            setSelectableCards(props.cards.filter(c=>c.rarity.name === "Normal" && (c.level.value === 2 || c.level.value === 3)));
            setProbabilities(Object.entries(response.data[0].probabilities).map(([name, value]) => ({ name, value })).filter((p) => p.name !== "Fail"));
          }
        }
        const syntesis = async () => {
          if(selectedCards.length < 3){
            showToaster({type:"error",message:"You must select 3 cards."});
            return;
          }
          const userBalance = user?.balances[craftKey?._id] || 0;
          if(userBalance < synthesisType.price){
            showToaster({type:"error",message:"You do not have enough Craft Key."});
            return;
          }
          setIsLoading(true);
          try {
              const response = await synthesisCard({materialCards:selectedCards.map(c=>c._id),synthesis:synthesisType});
              if(response?.success){
                let isSuccessful = !!response.data.upgradedCard;
                if(synthesisType.returnCardCount === 0 && !isSuccessful){
                  setIsLoading(false);
                  showToaster({type:"error",message:"Synthesis failed Your cards burned."});
                  return;
                }
              
                const title = response.data.upgradedCard ? "Successful" : "Returned Card";
                let cryptid = isSuccessful
                  ? {
                      name: response.data.upgradedCard.card.name,
                      level: { value: response.data.upgradedCard.level.value },
                      type: response.data.upgradedCard.card.cryptidType,
                      rarity: response.data.upgradedCard.card.rarity,
                      weakness: response.data.upgradedCard.card.weaknessType,
                      miningPower: response.data.upgradedCard.miningPower,
                      imageUri: response.data.upgradedCard.card.imageUri,
                    }
                  : selectedCards[0];
                setIsLoading(false);
                  openUpgradeResultModal(cryptid, isSuccessful,title);
              }else{
                setIsLoading(false);
                showToaster({type:"error",message:response.message});
              }
          } catch (error) {
            console.log(error);
            setIsLoading(false);
            showToaster({type:"error",message:"An error occured while processing your request."});
            
          }
          return;
        }

        const handleSytesisType = (value) => {
          if(!synthesisData){
            return;
          }
          const syntesis = synthesisData.find(s=>s.name === value)
          setSystesisType(syntesis);
          setSelectedCards([]);
          switch (syntesis.name) {
            case "Normal":
              setSelectableCards(userCards.filter(c=>c.rarity.name === syntesis.name && (c.level.value === 2 || c.level.value === 3)));
              break;
            case "NormalLv3":
              setSelectableCards(userCards.filter(c=>c.rarity.name === "Normal" && (c.level.value === 3)));
              break;
            case "Rare":
              setSelectableCards(userCards.filter(c=>c.rarity.name === syntesis.name && (c.level.value === 2 || c.level.value === 3)));
              break;
            case "RareLv3":
              setSelectableCards(userCards.filter(c=>c.rarity.name === "Rare" && (c.level.value === 3)));
              break;
            case "UniqueLv2":
              setSelectableCards(userCards.filter(c=>c.rarity.name === "Unique" && (c.level.value === 2)));
              break;
            case "Legend":
              setSelectableCards(userCards.filter(c=>c.rarity.name === syntesis.name));
              break; 
            default:
              setSelectableCards(userCards.filter(c=>c.rarity.name === syntesis.name && c.level.value === 3));
              break;
          }          
          setProbabilities(Object.entries(syntesis.probabilities).map(([name, value]) => ({ name, value })).filter((p) => p.name !== "Fail"));
        };
  return (
    <ScrollableContainer style={{position:"relative",paddingTop:"48px"}}>
        <FilterTab>
            <h5>
              Syntesis Type:
            </h5>
          <CustomSelect
              options={[
                  {label:"Normal Lv2",value:"Normal"},
                  {label:"Normal Lv3",value:"NormalLv3"},
                  {label:"Rare Lv2",value:"Rare"},
                  {label:"Rare Lv3",value:"RareLv3"},
                  {label:"Unique Lv2",value:"UniqueLv2"},
                  {label:"Unique Lv3",value:"Unique"},
                  {label:"Legend",value:"Legend"},
              ]}
              value={synthesisType?.name}
              onChange={(value)=>handleSytesisType(value)}
          />
      </FilterTab>
      <FlexContainer>
      {probabilities.length > 0 && 
      React.Children.toArray(
        probabilities.map((p) => (
            <ProgressContainer>
                <span>
                <span>{p.name}</span>
                </span>
                <ProgressBar
                  barStyle={{ border: "none" }}
                  wrapperStyle={{
                    border: "none",
                    maxWidth: "calc(60 * var(--vw))",
                    background: "#16273D",
                    boxShadow: "0px 4px 4px 0px #00000040 inset",
                  }}
                  progress={p.value * 100}
                />
                <span style={{position:"absolute",bottom:"3px",right:"8px",fontSize:"12px"}}>{p.value * 100}%</span>
            </ProgressContainer>
        ))
      )
      }
      </FlexContainer>
      <SytesisTop>
        <img src={SyntesisCard} alt="Syntesis Card" />
      </SytesisTop>
      <SytesisBottom>
        <h3>Material Cards</h3>
        <FlexContainer style={{flexBasis:"1 1 25%"}} gap="8px">
            {MaterialCards}
        </FlexContainer>
        <FlexContainer gap="4px">
            <span>COST:  {synthesisType.price}</span>
            <img style={{maxWidth:"24px"}} src={craftKey?.imageUri} alt="Craft Key Logo" />
            <span>CRAFT</span>
        </FlexContainer>
        <PrimaryButton onClick={syntesis} style={{maxWidth:"180px"}}>{"Syntesis"}</PrimaryButton>
      </SytesisBottom>
      <CraftKeyMainContainer>
      <CraftKeyContainer>
        <img src={craftKey?.imageUri} alt="Craft Key" />
      </CraftKeyContainer>
      <span>{user?.balances[craftKey?._id] || 0}</span>
      </CraftKeyMainContainer>
    </ScrollableContainer>
  );
};

const ProgressContainer = styled(FlexContainer)`
  flex-direction: column;
  margin-top: 16px;
  gap: 8px;
  margin-bottom: 16px;
  position: relative;
  h3 {
    font-size: 1.2em;
    font-weight: 500;
    span {
      font-weight: 800;
    }
  }
`;
const SytesisTop = styled(FlexContainer)`
  margin-bottom: 16px;
   background: url(${SyntesisBg}) center / 60% 90% no-repeat;
  img{
    width: 100%;
    max-width: 118px
  }
  animation: ${floatCard} 3s ease-in-out infinite
`;
const SytesisBottom = styled(FlexContainer)`
   flex-direction: column;
   h3{
         font-size: 1.2em;
         font-weight: 500;
   }
   margin-bottom: 34px;
`;
const FilterTab = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    gap:8px;
    padding:8px;
    border-radius: 12px;
    background-color:rgba(65, 65, 66, 0.18);
    backdrop-filter: blur(52.70000076293945px);
    -webkit-backdrop-filter: blur(52.70000076293945px);
    height: 48px;
    width: 100%;
    border-radius: 12px;
    margin-bottom: 8px;
    position: absolute;
    top:8px;
    z-index: 1;
`;
const CraftKeyMainContainer = styled(FlexContainer)`
    position: absolute;
    right: 0px;
    top: 20vh;
    flex-direction: column;
    width: 60px;
    gap: 4px;
    span{
      font-size: 12px;
      font-weight: 600;
      color: white;
    }
`
const CraftKeyContainer = styled(FlexContainer)`
    border-radius: 50px;
    border:2px solid white;
    width: 44px;
    height: 44px;
    background-blend-mode: overlay;
    background: linear-gradient(180deg,rgba(255, 255, 255, 0.34) 0%, rgba(255, 255, 255, 0) 100%);
    backdrop-filter: blur(13px);
    img{
      width: 24px;
    }
`
// const Badge = styled.span`
//     background-color: #6B48AC;
//     /* position: absolute; */
//     border-radius:12%;
//     border:1px solid white;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     color: white;
//     font-size: 12px;
//     /* width: 20px;
//     height: 20px; */
//     right: -4px;
//     bottom: -4px;
// `

export default Syntesis;
